export default __webpack_public_path__ + "static/media/moon.cfa37b17.png";